module.exports = "<i class=\"spark-icon--fill spark-icon-check system-status-done\" title={{value}}></i>";